module.exports = __webpack_public_path__ + "static/media/bum2_munich.6406da0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/thumbs/bum2_munich.jpg
// module id = 442
// module chunks = 0